export default __webpack_public_path__ + "static/media/CV5.345c412d.jpg";